import axios from 'axios'
import * as Util from '@/vuex/util'

const state = {
  locations: []
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.locations = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.locations = []
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.locations
}

export const Locations = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/maps/Locations.js